import { useLocation, useHistory } from 'react-router-dom';

const useComingFromPublish = () => {
  const location = useLocation();
  const history = useHistory();
  const comingFromPublish = location?.state?.isComingFrom === '/cursos/editar/publicar';
  if (comingFromPublish) {
    history.replace();
  }
  return comingFromPublish;
};

export default useComingFromPublish;
